<div class="col-12" style="text-align: right!important;">
    <p-button pRipple type="button" (click)="showDialog()" icon="fas fa-pencil" styleClass="p-button-sm p-button-info" pTooltip="Editare" tooltipPosition="left"></p-button> &nbsp;
    <p-button pRipple type="button" (click)="confirm()" icon="fas fa-trash" styleClass="p-button-sm p-button-danger" pTooltip="Stergere" tooltipPosition="left"></p-button>
</div>
